import { render, staticRenderFns } from "./confirm-default.vue?vue&type=template&id=324d28e1&scoped=true&"
import script from "./confirm-default.vue?vue&type=script&lang=js&"
export * from "./confirm-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d28e1",
  null
  
)

export default component.exports